import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { Grid } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import useForm from "../lib/useForm";
import { useSnackbar } from "notistack";
import config from "../../../config";
import { saveWebResult } from "../lib/sync/questionsLib";
import ThingsContext from "../../PublicLayout/thingsContext";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0),
  },
  edit: {
    backgroundColor: "#e8e8e8",
  },
}));

const defaultValues = () => {
  return {
    question: "",
    ans: {
      1: "True",
      2: "False",
    },
    Qtype: "True False",
    CorrectAnswer: "1",
    image: {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
    },
  };
};

export default function FullScreenDialog({ item, fetchNew }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [values, handleChange, resetForm] = useForm(defaultValues);
  const [block, setBlock] = useState(false);
  const [things] = useContext(ThingsContext);
  const [questions_id, setQuestionId] = useState(0);

  useEffect(() => {
    if (block) return;
    setBlock(true);
    if (item) {
      resetForm(item.question);
      setQuestionId(item.questions_id);
    }
  }, [block, item, resetForm]);

  const register = (e) => {
    e.preventDefault();
    saveObject(values);
    // if (!editId) restObject();
  };

  const saveObject = (question) => {
    let obj = {
      school_id: things[0],
      section_id: things[2],
      student_id: things[5],
      question_attempts: 1,
      question_id: JSON.stringify([
        { attempted: true, question_id: questions_id },
      ]),
      question_count: 5,
      is_from_video: 0,
    };

    saveWebResult(obj)
      .then((res) => {
        console.log("res", res);
        fetchNew();
        enqueueSnackbar(`Question Answer Added Successfully.`);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <form onSubmit={register}>
      <hr />
      <Grid container spacing={2}>
        <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
          <h3>{values.question}</h3>
        </Grid>
        <Grid item xs={4}>
          {values.questionImage && (
            <img
              className={classes.image}
              src={config.imageCDN + values.questionImage}
              title={values.questionImage.split("/").pop()}
              alt={values.questionImage.split("/").pop()}
              width={100}
            />
          )}
        </Grid>
        {[1, 2].map((x) => {
          return (
            <React.Fragment key={x}>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <Grid item xs={6}>
                    <InputLabel htmlFor="outlined-adornment-amount">
                      Answer: {values.ans[x]}
                    </InputLabel>
                  </Grid>
                  {/* <InputLabel htmlFor="outlined-adornment-amount">
                    Answer
                  </InputLabel> */}
                  {/* <OutlinedInput
                    name={`ans--${x}`}
                    value={values.ans ? values.ans[x] : ""}
                    onChange={handleChange}
                    startAdornment={
                      <InputAdornment position="start">
                        Option {x}
                      </InputAdornment>
                    }
                    labelWidth={60}
                  /> */}
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                {values["image"][x] && (
                  <img
                    className={classes.image}
                    src={config.imageCDN + values["image"][x]}
                    alt={values["image"][x].split("/").pop()}
                    width={100}
                  />
                )}
                {/* <ImageUpload
                  editImage={values["image"][x]}
                  blobContainer={props.selection}
                  label="Select Image"
                  blobItem={blobItem}
                  name={`image--${x}`}
                  restImages={restImages}
                /> */}
              </Grid>
              <Grid item xs={3}>
                <Radio
                  checked={parseInt(values.CorrectAnswer) === x}
                  onChange={handleChange}
                  value={x}
                  name="CorrectAnswer"
                  // inputProps={{ "aria-label": "A" }}
                />
              </Grid>
            </React.Fragment>
          );
        })}
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
